/**
 * The MCP endpoint URL and the connect command shown on the account page.
 *
 * Kept out of the component so the exact strings are testable: the endpoint
 * has to match the server's configured audience byte for byte, or the token a
 * client obtains is minted for the wrong resource and every call 401s.
 */

import { apiOrigin } from './origins';

/**
 * `<api origin>/mcp`.
 *
 * Derived from the *origin* of the API base URL, not the base URL itself:
 * `VITE_API_BASE_URL` carries the `/v1` prefix (`http://localhost:8003/v1`),
 * and the MCP endpoint is mounted at the root, sibling to the `/v1` scopes.
 * Appending to the base would advertise `/v1/mcp`, which 404s.
 */
export function mcpEndpointUrl(apiBaseUrl?: string): string {
  return `${apiOrigin(apiBaseUrl ?? '')}/mcp`;
}

/** The one-liner a user pastes into a terminal to connect Claude Code. */
export function mcpConnectCommand(endpointUrl: string): string {
  return `claude mcp add --transport http formshive ${endpointUrl}`;
}
